import React,{Component} from 'react';
import $ from 'jquery';
import Swiper from 'react-id-swiper';
import {Link} from 'react-router';
 
const baseUrl='https://aquadeals.in/admin/web3/user/';
const baseAssets='https://aquadeals.in/admin/assets/';

export default class WebBrandStoreBlocks extends Component
{
	constructor(props)
	{
		super(props);
		this.state={
			deal_offers:[],
		}
    this.getBrandStores =this.getBrandStores.bind(this);
	  this.storeClicks =this.storeClicks.bind(this); 
    this.goNext = this.goNext.bind(this);
    this.goPrev = this.goPrev.bind(this);
	}
	componentDidMount()
	{
		this.getBrandStores(); 
	}
	getBrandStores()
	{
       var data1 = {from:'desktop_web'}
       var data2 =JSON.stringify(data1);
       $.ajax({
           url:baseUrl+'brand_store',
           method:'POST',
           data:{req:data2},
           dataType:'JSON',
           success:function(data)
           {
               if(data.status === 'success')
               {
               	 this.setState({deal_offers:data.deal_offers});
               }
           }.bind(this),
           error:function(err)
           {

           }

       }); 
	}
	storeClicks(id)
   {
       if(localStorage.user_id)
       {
         var uid = localStorage.user_id;
       }
       else
       {
          uid =0;
       }
       var data1 ={from:'desktop_web',uid:uid,id:id}
       var data2 =JSON.stringify(data1);
       $.ajax({
          url:baseUrl+'storeClicks',
          method:'POST',
          data:{req:data2},
          dataType:'JSON',
          success:function(data)
          {

          },
          error:function(err)
          {

          }
       });
    }   
  goNext()
  {
      if(this.swiper) this.swiper.slideNext()
  }
  goPrev()
  {
      if(this.swiper) this.swiper.slidePrev()
  }
	render()
	{
		var params ={
			paginationClickable:true,
			slidesPerView:3,
			spaceBetween:10,
			parallax:true,
			 parallaxEl: {
	        el: '.parallax-bg',
	        value: '-23%'
	      },

       navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
		}
       var brands = this.state.deal_offers.map(function(brand,index){
           return(
               <Link to={brand.redirect_url ? '/web'+brand.redirect_url: '#'} onClick={()=>{this.storeClicks(brand.row_id)}}>
                  {brand.img ? <img src={baseAssets+'images/'+brand.img}  alt="" /> : ''}
               </Link>
     	);  

       }.bind(this));

		return(
		    <section className="web_brnds_blk">	
           <div className="Webbrand_stores_blk" >
              {brands.length > 0 ? 
               <div className="container" style={{padding:'0px'}}> 
                  <h4 className="web_blk_titles">Brand Stores</h4>
                    <div className="pro_sld_ctrls pull-right">
                      <a className="left carousel-control pro_sld_lft" onClick={this.goPrev}>
                        <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/left_arrow.png'} alt="" /></span>
                        <span className="sr-only">Previous</span>
                      </a>
                      <a className="right carousel-control pro_sld_rgt" onClick={this.goNext}>
                        <span className="pro_sld_arow" aria-hidden="true"><img src={baseAssets+'images_web/right_arrow.png'} alt="" /></span>
                        <span className="sr-only">Next</span>
                      </a>
                    </div>
               </div> 
                :''}
              <div className="container" style={{backgroundColor:'#fff',padding:'0px 0px 10px 0px',marginTop:'15px'}}>
                <Swiper {...params} key={brands.length} ref={node => node ? this.swiper = node.swiper : ''}>
                   {brands}
                </Swiper>
              </div>
           </div>
        </section>   
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Stores/WebBrandStoreBlocks.js
 **/